import { Info } from "lucide-react";
import { Logo } from "@/components/Logo";
import { scrollToSection } from "@/lib/scroll";

const LINKS = [
  { label: "The Man", hash: "#about" },
  { label: "Record", hash: "#record" },
  { label: "Westlands", hash: "#westlands" },
  { label: "Movement", hash: "#movement" },
  { label: "Vision 2027", hash: "#vision" },
  { label: "Join", hash: "#join" },
];

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-white/10 bg-[#0B0C10]">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-16 pb-10">
      <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-10">
        <div>
          <div className="flex items-center gap-4">
            <Logo size={52} />
            <div>
              <p className="font-display font-extrabold text-3xl sm:text-4xl tracking-tight leading-none">
                WANYONYI<span className="text-orange-500">'27</span>
              </p>
              <p className="mono text-[10px] tracking-[0.3em] uppercase text-stone-500 mt-2">
                Bungoma Governor Bid
              </p>
            </div>
          </div>
          <div
            data-testid="footer-disclaimer"
            className="mt-8 max-w-xl flex items-start gap-3 rounded-2xl border border-orange-500/25 bg-orange-600/[0.06] px-5 py-4"
          >
            <Info size={16} className="text-orange-500 mt-0.5 shrink-0" />
            <p className="text-xs text-stone-400 leading-relaxed">
              This is a demo campaign website created for informational and presentation
              purposes, based on publicly available information. It is not an official
              campaign communication of Hon. Tim Wanyonyi.
            </p>
          </div>
        </div>

        <nav className="grid grid-cols-2 gap-x-12 gap-y-3" data-testid="footer-nav">
          {LINKS.map((l) => (
            <button
              key={l.hash}
              data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              onClick={() => scrollToSection(l.hash)}
              className="text-left mono text-xs tracking-[0.18em] uppercase text-stone-500 hover:text-orange-400 transition-colors"
            >
              {l.label}
            </button>
          ))}
        </nav>
      </div>

      <div className="mt-14 pt-6 border-t border-white/5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
        <p className="mono text-[11px] tracking-[0.14em] uppercase text-stone-600">
          © 2026 Tim Wanyonyi 2027 — Demo
        </p>
        <p className="mono text-[11px] tracking-[0.14em] uppercase text-stone-600">
          Service · Integrity · Progress
        </p>
      </div>
    </div>
  </footer>
);
